import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterAny',
    standalone: false
})
export class FilterAnyPipe implements PipeTransform {

    transform(items: any[], filters: any, isAnd: boolean): any[] {
        if (!items) return [];
        if (!filters) return items;
    
        return items.filter(item => {
          let match = false;
          for (const key in filters) {
            if (item[key] === filters[key]) {
              if (isAnd) {
                match = true;
              } else {
                return true;
              }
            } else if (isAnd) {
              return false;
            }
          }
          return match;
        });
      }

}